import {
  languageConstants,
} from '../constants/languageConstants';

let localLanguage = localStorage.getItem('language');

if (localLanguage !== undefined && localLanguage !== 'undefined') {
  localLanguage = JSON.parse(localStorage.getItem('language'));
}

let initialState = {
  language: '',
};
if (localLanguage) {
  initialState = {
    language: localLanguage,
  };
}

export default function language(state = initialState, action) {
  switch (action.type) {
    case languageConstants.SET_LANGUAGE:
      return {
        ...state,
        language: action.language,
      };
    case languageConstants.UNSET_LANGUAGE:
      return {};
    default:
      return state;
  }
}
